/* ============================================================
   SOLVEY · Intimate Shave Bar — pack-size toggle
   ------------------------------------------------------------
   Firmhouse rendert twee <section data-variant-id>'s op deze PDP:
     - 57493251391820  (Scheerblok enkel,  €12,95)
     - 57493399994700  (Scheerbar 3 maanden 2-pack, €25,00)
   De 2-pack section is via Firmhouse-JS verborgen tot een variant-
   selector switcht. We tonen beide via CSS en synchroniseren hier:

   1) Cross-section radio sync: radios in beide sections krijgen
      dezelfde `name` zodat de browser ze als één groep behandelt.
   2) Bij radio-change: zet <select name="id"> in product-form op de
      bijbehorende variant_id zodat /cart/add de juiste variant krijgt.
   3) Relabel de "Eenmalige aankoop" tekst in de 2-pack card naar
      "3 maanden · 2-pack" voor duidelijkheid voor de klant.
   4) Default-selection = Single (origineel zichtbare default voor
      mijn CSS-unhide). Wordt alleen geforceerd zolang de gebruiker
      zelf nog niet heeft geklikt; daarna respecteren we hun keuze.
   ============================================================ */
(function () {
  'use strict';

  if (!document.body.classList.contains('product-handle--intimate-shave-bar')) return;

  var SINGLE_VARIANT = '57493251391820';
  var PACK_VARIANT = '57493399994700';
  var PACK_LABEL = '3 maanden · 2-pack';
  var UNIFIED_NAME = 'solvey_shavebar_purchase_option';

  var userHasPicked = false;

  // Lucide-style icons (matchen restore-probiotics-bullets.js conventie).
  var ICONS = {
    trophy:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/>' +
      '<path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/>' +
      '<path d="M4 22h16"/>' +
      '<path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/>' +
      '<path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/>' +
      '<path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/>' +
      '</svg>',
    sparkles:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>' +
      '<path d="M20 3v4"/>' +
      '<path d="M22 5h-4"/>' +
      '<path d="M4 17v2"/>' +
      '<path d="M5 18H3"/>' +
      '</svg>',
    calendarCheck:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M8 2v4"/>' +
      '<path d="M16 2v4"/>' +
      '<rect width="18" height="18" x="3" y="4" rx="2"/>' +
      '<path d="M3 10h18"/>' +
      '<path d="m9 16 2 2 4-4"/>' +
      '</svg>',
    package:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M16.5 9.4 7.55 4.24"/>' +
      '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>' +
      '<path d="M3.27 6.96 12 12.01l8.73-5.05"/>' +
      '<path d="M12 22.08V12"/>' +
      '</svg>',
    pauseCircle:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="10"/>' +
      '<line x1="10" x2="10" y1="15" y2="9"/>' +
      '<line x1="14" x2="14" y1="15" y2="9"/>' +
      '</svg>'
  };

  var PACK_BULLETS = [
    { icon: ICONS.trophy,        text: 'Best value: save the most' },
    { icon: ICONS.sparkles,      text: 'Long-lasting care for smooth, comfortable skin' },
    { icon: ICONS.calendarCheck, text: 'Fewer reorders, more convenience' },
    { icon: ICONS.package,       text: 'Always have a backup on hand' },
    { icon: ICONS.pauseCircle,   text: 'Pause or cancel anytime' }
  ];
  var BULLETS_HASH = PACK_BULLETS.map(function (b) { return b.text; }).join('|');
  var BULLETS_FLAG = 'data-solvey-pack-bullets';

  function getWidget() {
    return document.querySelector('fh-selling-plans-widget');
  }

  function getForm() {
    return document.querySelector('form[action*="/cart/add"][data-product-handle="intimate-shave-bar"]');
  }

  function setFormVariant(variantId) {
    var form = getForm();
    var select = form && form.querySelector('select[name="id"], input[name="id"]');
    if (!select) return;
    if (select.value === variantId) return;
    select.value = variantId;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setFormQuantity(qty) {
    var form = getForm();
    var qtyInput = form && form.querySelector('input[name="quantity"]');
    if (!qtyInput) return;
    if (String(qtyInput.value) === String(qty)) return;
    qtyInput.value = qty;
    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setFormSellingPlan(planId) {
    var form = getForm();
    var input = form && form.querySelector('input[name="selling_plan"]');
    if (!input) return;
    var nextValue = planId || '';
    if (input.value === nextValue) return;
    input.value = nextValue;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // 2-pack card oogt visueel als "one-time" maar moet als ABONNEMENT in cart.
  // Lees plan-ID uit de verborgen subscription-card binnen dezelfde section
  // (geselecteerde frequency-select value, default 6 weken / 690761924940).
  // Returns '' voor non-2-pack-one-time radios — Firmhouse handelt die zelf af.
  function readSellingPlanForRadio(checkedRadio, section) {
    var rt = checkedRadio.dataset.radioType;
    var variant = section.dataset.variantId;
    if (variant === PACK_VARIANT && rt === 'one_time_purchase') {
      var freqSelect = section.querySelector('li.subscription-card select.frequency-select');
      return freqSelect ? freqSelect.value : '';
    }
    return null; // null = niet override'en, laat Firmhouse beslissen
  }

  // Elke card-keuze koppelt aan de variant van zijn eigen section:
  // - 2-pack card → variant 57493399994700 (SKU 87208924927462P, eigen
  //   voorraadpool van het 2-pack zoals zichtbaar in Shopify admin)
  // - Single one-time / subscription → variant 57493251391820 (Single SKU)
  // Firmhouse hijackt form submit en override't variant naar de section
  // ZONDER `--hidden` class. CSS toont beide visueel, maar Firmhouse'
  // ATC-logic kijkt naar deze class. Dus toggle 'm bij elke selectie.
  function applyCartTarget(checkedRadio) {
    var widget = getWidget();
    if (!widget) return;
    var section = checkedRadio.closest('.selling_plan_theme_integration');
    if (!section) return;
    var targetVariant = section.dataset.variantId;
    // Marker de geselecteerde section als "actief" voor Firmhouse (geen
    // --hidden) en de andere als hidden. CSS unhide-override blijft beide
    // tonen, maar Firmhouse submit-logic gebruikt nu de juiste variant.
    var allSections = widget.querySelectorAll('.selling_plan_theme_integration');
    allSections.forEach(function (s) {
      var isActive = s.dataset.variantId === targetVariant;
      s.classList.toggle('selling_plan_theme_integration--hidden', !isActive);
    });
    setFormVariant(targetVariant);
    setFormQuantity(1);

    // UI-feedback: zet selling_plan direct zodat de zichtbare prijs/labels
    // correct lijken. Firmhouse wist dit op t=5ms en t=111ms terug naar '',
    // dus de echte garantie zit in de submit-enforcer + fetch-interceptor
    // hieronder — die corrigeren de form vlak voor de POST naar /cart/add.
    var planOverride = readSellingPlanForRadio(checkedRadio, section);
    if (planOverride !== null) setFormSellingPlan(planOverride);
  }

  /* ============================================================
     SUBMIT-TIME ENFORCER + FETCH INTERCEPTOR
     ------------------------------------------------------------
     Firmhouse's subscription-options.js wist `input[name="selling_plan"]`
     op t=5ms en t=111ms na een klik op een one_time_purchase radio.
     setTimeout(0) overrides verliezen die race. Daarom corrigeren we
     de form-waarden op het laatst mogelijke moment: vlak vóór POST naar
     /cart/add. Op dat punt maakt het niet meer uit wat Firmhouse onderweg
     deed met de inputs.

     Layer 1 — capture-phase submit handler: voor native form submits.
     Layer 2 — fetch monkey-patch: voor AJAX add-to-cart (Foxify gebruikt
     fetch). FormData/URLSearchParams body wordt direct gecorrigeerd.

     Mapping per gekozen radio (zelfde logica als applyCartTarget):
       - one_time_purchase + 2-pack variant => variant=2pack + selling_plan=6wk plan
       - one_time_purchase + single variant => variant=single + geen selling_plan
       - selling_plan (subscription-card)   => variant=section variant + selling_plan=freq.value
     ============================================================ */
  function computeDesired() {
    var checked = document.querySelector('input[name="' + UNIFIED_NAME + '"]:checked');
    if (!checked) return null;
    var section = checked.closest('.selling_plan_theme_integration');
    if (!section) return null;
    var sectionVariant = section.dataset.variantId;
    var type = checked.dataset.radioType;

    if (type === 'one_time_purchase' && sectionVariant === PACK_VARIANT) {
      var freq = section.querySelector('li.subscription-card select.frequency-select');
      return { variant: PACK_VARIANT, sellingPlan: (freq && freq.value) || '690761924940' };
    }
    if (type === 'one_time_purchase') {
      return { variant: sectionVariant, sellingPlan: '' };
    }
    if (type === 'selling_plan') {
      var freq2 = section.querySelector('li.subscription-card select.frequency-select');
      return { variant: sectionVariant, sellingPlan: (freq2 && freq2.value) || '' };
    }
    return null;
  }

  function enforceFormState() {
    var form = getForm();
    if (!form) return null;
    var desired = computeDesired();
    if (!desired) return null;
    var sel = form.querySelector('select[name="id"], input[name="id"]');
    var sp = form.querySelector('input[name="selling_plan"]');
    if (sel && sel.value !== desired.variant) sel.value = desired.variant;
    if (sp && sp.value !== desired.sellingPlan) sp.value = desired.sellingPlan;
    return desired;
  }

  function installSubmitEnforcer() {
    var form = getForm();
    if (!form || form.dataset.solveyEnforcerInit === '1') return;
    form.dataset.solveyEnforcerInit = '1';
    // Capture-phase: vuurt vóór alle andere submit-listeners
    form.addEventListener('submit', function () { enforceFormState(); }, true);
  }

  function installFetchInterceptor() {
    if (window.__solveyShavebarFetchPatched) return;
    window.__solveyShavebarFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url);
        if (url && url.indexOf('/cart/add') !== -1) {
          enforceFormState();
          var desired = computeDesired();
          if (desired && init && init.body) {
            if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
              if (init.body.get('id') !== desired.variant) init.body.set('id', desired.variant);
              if (desired.sellingPlan) init.body.set('selling_plan', desired.sellingPlan);
              else init.body.delete('selling_plan');
            } else if (typeof init.body === 'string') {
              try {
                var params = new URLSearchParams(init.body);
                if (params.get('id') !== desired.variant) params.set('id', desired.variant);
                if (desired.sellingPlan) params.set('selling_plan', desired.sellingPlan);
                else params.delete('selling_plan');
                init.body = params.toString();
              } catch (e) { /* niet-URL-encoded body — laat staan */ }
            }
          }
        }
      } catch (e) { /* defensive — fetch nooit blokkeren door bug */ }
      return origFetch.apply(this, arguments);
    };
  }

  function buildBulletsList() {
    var ul = document.createElement('ul');
    ul.className = 'solvey-pack-bullets';
    ul.setAttribute(BULLETS_FLAG, BULLETS_HASH);
    PACK_BULLETS.forEach(function (b) {
      var li = document.createElement('li');
      li.innerHTML = b.icon + '<span>' + b.text + '</span>';
      ul.appendChild(li);
    });
    return ul;
  }

  function injectPackBullets(widget) {
    var packCard = widget.querySelector('.selling_plan_theme_integration[data-variant-id="' + PACK_VARIANT + '"] li.one-time-purchase .content');
    if (!packCard) return;
    var existing = packCard.querySelector('.solvey-pack-bullets');
    if (existing) {
      if (existing.getAttribute(BULLETS_FLAG) === BULLETS_HASH) return;
      existing.parentNode.removeChild(existing);
    }
    packCard.appendChild(buildBulletsList());
  }

  function getMasterRadios(widget) {
    return widget.querySelectorAll(
      'input[type="radio"][data-radio-type="one_time_purchase"], ' +
      'input[type="radio"][data-radio-type="selling_plan"]'
    );
  }

  function isVisibleEl(el) {
    return el && el.getBoundingClientRect().height > 0;
  }

  function syncUI() {
    var widget = getWidget();
    if (!widget) return;

    // Relabel 2-pack option-name (idempotent via dataset flag).
    var packOptionName = widget.querySelector('.selling_plan_theme_integration[data-variant-id="' + PACK_VARIANT + '"] .option-name');
    if (packOptionName && !packOptionName.dataset.solveyRelabeled) {
      packOptionName.textContent = PACK_LABEL;
      packOptionName.dataset.solveyRelabeled = '1';
    }

    injectPackBullets(widget);

    // Unify name op ALLE master radios (one-time + subscription) zodat
    // browser ze als één mutually-exclusive groep behandelt. Frequency-
    // radios binnen subscription-card behouden hun Firmhouse-namen.
    var allMasters = getMasterRadios(widget);
    allMasters.forEach(function (r) {
      if (r.name !== UNIFIED_NAME) r.name = UNIFIED_NAME;
    });

    if (!userHasPicked) {
      // Default: alleen Single subscription master gecheckt.
      var defaultRadio = widget.querySelector(
        '.selling_plan_theme_integration[data-variant-id="' + SINGLE_VARIANT + '"] ' +
        'li.subscription-card input[type="radio"][data-radio-type="selling_plan"]'
      );
      allMasters.forEach(function (r) {
        r.checked = (r === defaultRadio);
      });
      if (defaultRadio) applyCartTarget(defaultRadio);
    } else {
      // User heeft gekozen — form-variant + quantity in sync brengen met
      // wat momenteel checked is onder de visible masters.
      var checked = null;
      for (var i = 0; i < allMasters.length; i++) {
        if (allMasters[i].checked && isVisibleEl(allMasters[i])) {
          checked = allMasters[i]; break;
        }
      }
      if (checked) applyCartTarget(checked);
    }
  }

  function onRadioChange(e) {
    var target = e.target;
    if (!target || target.type !== 'radio') return;
    var rt = target.dataset.radioType;
    if (rt !== 'one_time_purchase' && rt !== 'selling_plan') return;
    userHasPicked = true;
    applyCartTarget(target);
  }

  function attach() {
    var widget = getWidget();
    if (!widget) return false;
    if (widget.dataset.solveyPackInit !== '1') {
      widget.addEventListener('change', onRadioChange);
      widget.dataset.solveyPackInit = '1';
    }
    installSubmitEnforcer();
    syncUI();
    return true;
  }

  function init() {
    if (attach()) return;
    // Widget nog niet in DOM — wacht via observer op body.
    var bodyObserver = new MutationObserver(function () {
      if (attach()) bodyObserver.disconnect();
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Fetch interceptor moet zo vroeg mogelijk geïnstalleerd worden,
  // vóór andere scripts (Foxify cart-handler) hun eigen patches op
  // window.fetch leggen. Dit is een no-op als de widget niet rendert.
  installFetchInterceptor();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Firmhouse kan de widget her-renderen; observer roept syncUI() opnieuw
  // aan zodat label + name-unification + form-variant correct blijven.
  var watcher = new MutationObserver(function () {
    var widget = getWidget();
    if (widget) syncUI();
  });
  // Pas observe na een tick zodat widget zeker bestaat.
  setTimeout(function () {
    var widget = getWidget();
    if (widget) watcher.observe(widget, { childList: true, subtree: true });
  }, 100);
})();
